/* eslint-disable react/iframe-missing-sandbox */
import { useState } from "react";
import styles from "./Feature.module.css";
import noVideo from "../../assets/images/novideo.png";
import anim1 from "../../assets/videos/Blue Working Cat Animation.json";
import anim2 from "../../assets/videos/Cat and Ball.json";
import anim3 from "../../assets/videos/Stress Management.json";
import Lottie from "react-lottie";
import ReactPlayer from "react-player";

const FeatureCard = ({ title, description, videoUrl, textColor, backgroundColor }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [randomAnim, setRandomAnim] = useState(null);

  const animations = [anim1, anim2, anim3];
  const openModal = () => {
    const randomIndex = Math.floor(Math.random() * animations.length);
    setRandomAnim(animations[randomIndex]);
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div
        className={styles.featureCard}
        style={{ backgroundColor }}
      >
        <div className={styles.content}>
          <h3
            className={styles.title}
            style={{ color: textColor }}
          >
            {title}
          </h3>
          <p className={styles.description}>{description}</p>
          <p
            className={styles.viewButton}
            onClick={openModal}
          >
            View Feature
          </p>
        </div>
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <div className={styles.modalContent}>
              <button
                className={styles.closeButton}
                onClick={closeModal}
              >
                &times;
              </button>
              <h2
                className={styles.modalTitle}
                style={{ color: textColor }}
              >
                {title}
              </h2>
              <p className={styles.modalDescription}>{description}</p>

              <div className={styles.videoContainer}>
                {videoUrl ? (
                  <ReactPlayer
                    url={videoUrl}
                    controls
                    width="100%"
                    height="400px"
                  />

                ) : (
                  <div className={styles.noVideo}>
                    {randomAnim ? (
                      <Lottie
                        options={{
                          loop: true,
                          autoplay: true,
                          animationData: randomAnim,
                          rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                          }
                        }}
                        height={300}
                        width={300}
                      />
                    ) : (
                      <img src={noVideo} alt="No video available" className={styles.placeholderImage} />
                    )}
                    <p>No video available for this feature</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FeatureCard;
